import React from 'react';

function ClinicSettingsCancelButton({ onClick, disabled = false, className = '' }) {
    return (
        <button
            type="button"
            className={`btn btn-sm btn-outline-secondary rounded-pill clinic-settings-btn-cancel ${className}`.trim()}
            onClick={onClick}
            disabled={disabled}
        >
            <i className="bi bi-x-lg me-1"></i>
            Cancel
        </button>
    );
}

export default ClinicSettingsCancelButton;
